import { LimitedSchemaMutationOptions, useMutation } from '@frontend/react-query-helpers';
import { SchemaDigitalForms } from '@frontend/schema';
import { IO } from '../../types';
import { endpointKeys } from '../keys';

export const useDismissBanner = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdateDismissBanner, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.updateDismissedBanner,
    mutationFn: (req) => SchemaDigitalForms.DismissBanner(req),
    ...options,
  });
};
